<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="card-wrapper type-modal" [formGroup]="objectiveForm">
    
    <div class="card !pb-4">
      <h3 class="green decoration mb-4">Detalles de la Meta</h3>

      <div class="form-wrapper mb-3">
        <span>Nombre de la Meta:</span>
        <input type="text" formControlName="name" placeholder="Ej: Meta de Ventas" [attr.disabled]="true">
      </div>

      <div class="form-wrapper mb-3">
        <span>Fecha de Inicio:</span>
        <input type="date" formControlName="start_date" [attr.disabled]="true">
      </div>

      <div class="form-wrapper mb-3">
        <span>Fecha de Fin:</span>
        <input type="date" formControlName="end_date" [attr.disabled]="true">
      </div>
    </div>

    <div class="card !pb-4">
      <h3 class="green" style="margin-bottom: 1.6rem;">&nbsp;</h3>

      <div class="form-wrapper mb-3">
        <span>Meta Programada:</span>
        <div class="flex w-full items-center">
          <input type="number" formControlName="objective" placeholder="Ej: 50" [attr.disabled]="true">
        </div>
      </div>

      <div class="form-wrapper mb-3">
        <span>Meta Conseguida:</span>
        <div class="flex w-full items-center">
          <input type="number" formControlName="achieved_objective" placeholder="Ej: 45" [attr.disabled]="true">
        </div>
      </div>

      <div class="form-wrapper mb-3">
        <span>Usuario Responsable:</span>
        <input type="text" formControlName="user_name" [attr.disabled]="true">
      </div>
    </div>

  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
    <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Aceptar</button>
  </div>
</div>